.ux-sidebar-footer {
  align-items: stretch;
  border-top: 1px solid $color-gray-background;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  justify-content: space-between;
  padding: $dim-30;
  width: 100%;

  .ux-button {
    flex: 1 0 auto;
    width: 100%;
  }
}
